import { monthOf } from '@/entities/performance/lib/performance';
import { ROUTE_PATHS } from '@/shared/constants/routes';

/** 실적 대시보드로 가는 링크 — 보던 달을 선택 월로 넘긴다 */
export const dashboardLink = (ym: string) => ({
  to: ROUTE_PATHS.PERFORMANCE,
  search: { year: Number(ym.slice(0, 4)), month: monthOf(ym) },
});

/** 전년 · 전월 대비 색 — 오르면 빨강, 내리면 파랑(info) */
export const deltaClass = (v: number | null | undefined) =>
  v === null || v === undefined || v === 0
    ? 'text-fg-tertiary'
    : v > 0
      ? 'text-fg-error'
      : 'text-fg-info';

/** presigned URL은 Content-Disposition(attachment)으로 오므로 링크 클릭만으로 저장된다 */
export const downloadFile = (url: string, fileName?: string) => {
  const a = document.createElement('a');
  a.href = url;
  if (fileName) a.download = fileName;
  a.rel = 'noopener';
  a.target = '_blank';
  document.body.appendChild(a);
  a.click();
  a.remove();
};
